"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var SubHeaderTools = function SubHeaderTools(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Tools, null, children));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "SubHeaderTools__Wrapper",
    componentId: "sc-1c29bsl-0"
})(["z-index:10;position:absolute;right:0;display:flex;background-color:", ";width:auto;height:calc(100% - 2px);&::after{z-index:2;position:absolute;top:0;left:-12px;background:linear-gradient( 90deg,", " 0%,", " 75%,", " 100% );height:100%;width:12px;pointer-events:none;content:'';}@media only screen and (min-width:", "){padding-right:20px;&::after{left:-40px;width:40px;}}"], _theme_1.palette.snow, _utils_1.rgba(_theme_1.palette.snow, 0), _utils_1.rgba(_theme_1.palette.snow, 1), _utils_1.rgba(_theme_1.palette.snow, 1), _theme_1.breakpoint.tablet);
var Tools = styled_components_1.default.div.withConfig({
    displayName: "SubHeaderTools__Tools",
    componentId: "sc-1c29bsl-1"
})(["display:flex;width:auto;height:calc(100% + 2px);"]);
exports.default = SubHeaderTools;
